import id from './{id}';
import history from './history';
import query from './query';
import get from './get';
import post from './post';

export type PostPayload = {
  active: boolean;
  eventType: boolean;
  fromEmail?: string;
  fromName?: string;
  headerTemplate?: string;
  name: string;
  ruleId: number;
  subjectTemplate?: string;
  type: string;
  urlTemplate: string;
};

export default { id, history, query, get, post };
